import { Info } from '@liveauctioneers/hammer-ui-core/icons';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodySecondary, LabelStrong } from '@liveauctioneers/hammer-ui-core/text';
import { Tooltip } from '@liveauctioneers/hammer-ui-core/tooltip';
import { ReactNode } from 'react';

type Props = {
    darkGrey?: boolean;
    info: ReactNode;
    popoverContent: ReactNode;
    price?: ReactNode;
    title: ReactNode;
};

export const ShippingMethodLabel = ({ darkGrey, info, popoverContent, price, title }: Props) => {
    return (
        <div className="w-full grid-rows-[3fr_1fr] gap-sm">
            <div className="flex w-full justify-between">
                <div className="flex items-center">
                    <LabelStrong color={darkGrey ? 'secondary' : 'primary'}>{title}</LabelStrong>
                    <Info
                        className="-mb-2xs ml-2xs"
                        color="primary"
                        id="shipping-method-label-info-trigger"
                        size="xs"
                        style="fill"
                    />
                    <Tooltip anchorSelect="#shipping-method-label-info-trigger">
                        <LabelStrong>
                            <FormattedMessage id="checkout.shippingMethod.popovers.title" />
                        </LabelStrong>
                        <BodySecondary>{popoverContent}</BodySecondary>
                    </Tooltip>
                </div>
                <LabelStrong>{price}</LabelStrong>
            </div>
            <BodySecondary color="secondary">{info}</BodySecondary>
        </div>
    );
};
